import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
// import { roleColumns } from './_columnsComit'
import { roleColumns } from './_columnsC'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../../../data-administration/data-admininstration-list/core/_requests'
import { useQueryRequest } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'


// const QualityList = () => {
//   // const [analyticsData, setAnalyticsData] = useState<any>(null)

//   // const { data } = useQuery(
//   //   `clients/101212/categories`,
//   //   () => getUserById('', 'clients/101212/categories'),
//   //   {
//   //     cacheTime: 0,
//   //     onError: (err) => {
//   //       console.warn(err)
//   //     },
//   //   }
//   // )
//   // const { updateState } = useQueryRequest()

//   // useEffect(() => {
//   //   const fetchCommitmentAnalytics = async () => {
//   //     try {
//   //       const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')
//   //       const token = authData?.data?.token

//   //       const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}commitments/analytics`, {
//   //         headers: {
//   //           'Authorization': token,
//   //           'Content-Type': 'application/json'
//   //         }
//   //       })

//   //       if (response.ok) {
//   //         const data = await response.json()
//   //         console.log('Commitment Analytics Response:', data)
//   //         setAnalyticsData(data)
//   //       } else {
//   //         console.error('API call failed:', response.status, response.statusText)
//   //       }
//   //     } catch (error) {
//   //       console.error('Error fetching commitment analytics:', error)
//   //     }
//   //   }

//   //   fetchCommitmentAnalytics()
//   // }, [])

//   return (
//     <KTCard>
//       <UsersListHeader  placeholder='Search' />
//       <UsersTable columnProps={roleColumns} />
//       <UserEditModal formName='CommitmentForm' />
//     </KTCard>
//   )
// }



const QualityList = () => {
  const [searchType, setSearchType] = useState('VOLUME_LINKED')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  const onConfirmDownload = async () => {
    try {
      if (!startDate || !endDate) {
        alert("Please select both start and end dates.")
        return
      }

      const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')
      const token = authData?.data?.token

      const formattedStartDate = startDate.split('-').reverse().join('/')
      const formattedEndDate = endDate.split('-').reverse().join('/')

      const params = new URLSearchParams({
        reportType: 'SPONSOR',
        clientId: authData?.data?.clientId,
        startDate: formattedStartDate,
        endDate: formattedEndDate
      })

      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/fulfillments/download/excel?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': token,
        }
      })

      if (!response.ok) {
        throw new Error('Download failed')
      }

      // Handle file download
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `Sponsor_Fulfillments_${formattedStartDate}_to_${formattedEndDate}.xlsx`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)

      setIsModalOpen(false)
      setStartDate('')
      setEndDate('')
    } catch (error) {
      console.error('Error downloading excel:', error)
      alert('Failed to download excel file')
    }
  }

  const searchTypeOptions = [
    { label: 'Prevention', value: 'VOLUME_LINKED' },
    { label: 'Household', value: 'USER_TYPE_LINKED' },
    { label: 'General', value: 'GENERAL' },
  ]

  return (
    <KTCard>
      <div style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "10px 30px"
      }}>
        <button
          type='button'
          style={{ backgroundColor: 'black' }}
          onClick={() => setIsModalOpen(true)}
          className='btn btn-primary fw-bold px-6'
          data-kt-menu-dismiss='true'
          data-kt-user-table-filter='filter'
        >
          Download
        </button>
        {/* <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <label style={{ fontWeight: 'bold' }}>Search by</label>
          <select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            style={{
              padding: '8px',
              border: '1px solid #dddddd',
              borderRadius: '4px',
              backgroundColor: '#ffffff',
            }}
          >
            {searchTypeOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div> */}
        {/* <UsersListHeader placeholder='Search' /> */}
      </div>

      <UsersTable columnProps={roleColumns} />
      <UserEditModal formName='NewFormModalForm' />

      {isModalOpen && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050,
          display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
          <div style={{
            backgroundColor: 'white', padding: '24px', borderRadius: '8px',
            width: '400px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ marginBottom: '20px', fontSize: '1.25rem', fontWeight: 'bold' }}>Download Report</h3>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Start date</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>End date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
              <button
                onClick={() => setIsModalOpen(false)}
                className='btn btn-light fw-bold px-6'
                style={{ border: '1px solid #ddd' }}
              >
                Cancel
              </button>
              <button
                onClick={onConfirmDownload}
                className='btn btn-primary fw-bold px-6'
                style={{ backgroundColor: 'black', border: 'none' }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </KTCard>
  )
}

const Fullfillment = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'sponsorCommitments' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { Fullfillment }

